"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBErrorNegative = function SvgBErrorNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M33.678 51.452a2.378 2.378 0 01-1.488-.486L1.747 27.255a2.427 2.427 0 112.977-3.794l30.443 23.646a2.427 2.427 0 01-1.489 4.345zM140.893 134.858a2.427 2.427 0 01-1.488-.517l-30.547-23.76a2.427 2.427 0 112.977-3.827l26.632 20.71V36.801a2.427 2.427 0 014.853 0v95.63a2.427 2.427 0 01-1.359 2.177c-.331.165-.697.25-1.068.25z"
  }), (0, _core.jsx)("path", {
    d: "M121.801 134.858H3.236a2.427 2.427 0 01-2.427-2.427V25.346a2.427 2.427 0 114.854 0v104.658H121.8a2.427 2.427 0 110 4.854z"
  }), (0, _core.jsx)("path", {
    d: "M140.893 27.773H3.236a2.427 2.427 0 010-4.854h135.23v-9.093a8.98 8.98 0 00-8.971-8.972H14.748a8.988 8.988 0 00-8.972 8.972 2.427 2.427 0 01-4.854 0C.932 6.194 7.116.009 14.748 0h114.747c7.632.009 13.817 6.194 13.825 13.826v11.52a2.427 2.427 0 01-2.427 2.427zM95.016 69.872c-.644 0-1.26-.256-1.715-.712l-7.678-7.677a2.428 2.428 0 013.439-3.43l7.677 7.677a2.427 2.427 0 01-1.723 4.142z"
  }), (0, _core.jsx)("path", {
    d: "M87.37 69.872a2.427 2.427 0 01-1.714-4.142l7.677-7.677a2.427 2.427 0 013.406 3.43l-7.677 7.677a2.427 2.427 0 01-1.691.712zM56.791 69.872c-.643 0-1.26-.256-1.715-.712l-7.677-7.677a2.427 2.427 0 113.43-3.43l7.677 7.677a2.427 2.427 0 01-1.715 4.142z"
  }), (0, _core.jsx)("path", {
    d: "M49.114 69.872a2.427 2.427 0 01-1.715-4.142l7.677-7.677a2.427 2.427 0 013.43 3.43L50.83 69.16a2.427 2.427 0 01-1.715.712zM94.951 96.553h-45.83a2.427 2.427 0 110-4.854h45.83a2.427 2.427 0 110 4.854zM14.788 16.333a2.427 2.427 0 110-4.853h.073a2.427 2.427 0 110 4.853h-.073zM26.316 16.333a2.427 2.427 0 110-4.853h.073a2.427 2.427 0 110 4.853h-.073zM37.788 16.333a2.427 2.427 0 11-.04-4.853h.072a2.427 2.427 0 110 4.853h-.032z"
  })));
};

var _default = SvgBErrorNegative;
exports["default"] = _default;